import * as React from 'react';
import { FormItem } from '../item/FormItem';

export interface IFormInputProps {
  name: string;
}

export type FormInputComponent<P extends IFormInputProps> =
  React.ComponentType<P>;

export interface IFormFieldProps<P extends IFormInputProps> {
  component: FormInputComponent<P>;
  noStyle?: boolean;
}

/**
 * Permette di renderizzare un campo di Input all'interno di un FormItem
 * con un solo componente.
 */
export function FormField<P extends IFormInputProps>(
  props: IFormFieldProps<P> & P,
) {
  const { component: Component, noStyle, name, ...inputProps } = props;
  return (
    <FormItem name={name} noStyle={noStyle}>
      <Component {...(inputProps as unknown as P)} name={name} />
    </FormItem>
  );
}
